function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.getHeight = t() : e.getHeight = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    n.r(t);

    var r = function r(e) {
      return new Promise(function (t) {
        return window.requestAnimationFrame(function (n) {
          return t(e ? e(n) : n);
        });
      });
    },
        o = function o(e, t) {
      var n = e.parentNode;
      if (!n) throw new ReferenceError("The old child has no parent node!");
      return n.insertBefore(t, e), n.removeChild(e), e;
    },
        i = function i(e, t) {
      var _window$getComputedSt = window.getComputedStyle(e),
          n = _window$getComputedSt.height,
          r = _window$getComputedSt.marginTop,
          o = _window$getComputedSt.marginBottom,
          i = _window$getComputedSt.paddingTop,
          d = _window$getComputedSt.paddingBottom,
          u = _window$getComputedSt.boxSizing,
          l = [n];

      return t && l.push(r, o), "border-box" !== u && l.push(i, d), function () {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }

        return e.reduce(function (e, t) {
          return e + parseFloat(t);
        }, 0);
      }.apply(void 0, l);
    };

    n.d(t, "getHeight", function () {
      return d;
    });

    var d = function d(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (!function (e) {
        return e.hidden || "none" === window.getComputedStyle(e).display;
      }(e)) return Promise.resolve(i(e, t));
      var n = document.createElement("div"),
          d = e.hidden,
          u = e.style.display;
      return Object.assign(n.style, {
        height: 0,
        margin: 0,
        padding: 0,
        overflow: "hidden"
      }), r(function () {
        n.appendChild(o(e, n)), e.style.display = "block", e.hidden = !1;
      }).then(function () {
        return r(function () {
          var r = i(e, t);
          return e.style.display = u, e.hidden = d, o(n, e), r;
        });
      });
    };
  }]);
});